<template>
  <div :class="classnames">
    <div :class="`${ns}__display`">
      <textarea ref="textarea" :class="`${ns}__textarea`" :value="text"></textarea>
    </div>

    <div :class="`${ns}__controls ${this.loading ? 'active' : 'default'}`">
      <vue-button v-if="!loading" appearance="black" @click="handleButtonClick">
        <template slot="text">{{ buttonLabel }}</template>
      </vue-button>
      <vue-button v-if="loading" appearance="black">
        <template slot="text">{{ successMessage }}</template>
      </vue-button>
    </div>
  </div>
</template>

<script>
  import VueButton from '@/components/VueButton'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'copy-text'

  export default {
    name: 'CopyText',
    components: {
      'vue-button': VueButton
    },
    mixins: [ bem ],
    props: {
      buttonLabel: {
        default: 'Copy',
        type: String
      },
      disableSuccessMessage: {
        default: false,
        type: Boolean
      },
      successMessage: {
        default: 'Copied!',
        type: String
      },
      text: {
        type: String
      }
    },
    data: function () {
      return {
        loading: false
      }
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      clearTextSelection: function () {
        if (window.getSelection) {
          if (window.getSelection().empty) { // Chrome
            window.getSelection().empty()
          } else if (window.getSelection().removeAllRanges) { // Firefox
            window.getSelection().removeAllRanges()
          }
        } else if (document.selection) { // IE?
          document.selection.empty()
        }
      },
      copyText: function () {
        document.execCommand('copy')
      },
      copyToClipboard: function () {
        const successMessageEnabled = !this.disableSuccessMessage

        this.clearTextSelection()
        this.selectText()
        this.copyText()

        if (successMessageEnabled) {
          this.reportSuccess()
        }

        this.clearTextSelection()
      },
      handleButtonClick: function () {
        this.copyToClipboard()
      },
      reportSuccess: function () {
        this.loading = true
        setTimeout(() => {
          this.loading = false
        }, 1500)
      },
      selectText: function () {
        const $el = this.$refs.textarea

        $el.select()
      }
    }
  }
</script>

<style lang="scss">
  .copy-text {
    .active .vue-button__text {
      animation: copyTextFadeIn ease 250ms;
    }
  }
  @keyframes copyTextFadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/components/CopyText.vue